<template>
    <div class="px-8">
        <div class="grid grid-cols-3 text-center text-tc-blue-1 text-20 cursor-pointer select-none mt-2" v-show="isShowCode">
            <div class="rounded-full py-1 font-main-bold"
                :class="[serialType == 'QR_CODE' ? classActiveTab : '']"
                @click="changeTab('QR_CODE')">
                {{lbl.serial.qr_code}}
            </div>
            <div class="rounded-full py-1 font-main-bold"
                :class="[serialType == 'CODE_128' ? classActiveTab : '']"
                @click="changeTab('CODE_128')">
                {{lbl.serial.barcode}}
            </div>
            <div class="rounded-full py-1 font-main-bold"
                :class="[serialType == 'CODE' ? classActiveTab : '']"
                @click="changeTab('CODE')">
                {{lbl.serial.code}}
            </div>
        </div>
        <div class="text-center text-20 text-tc-blue-1 mt-4">{{lbl.serial.show_code}}</div>
        <div class="flex justify-center items-center wrap-code">
            <div v-show="serialType == 'QR_CODE'">
                <VueQrcode :value="serial" :options="qrOption"></VueQrcode>
            </div>
            <div v-show="serialType == 'CODE_128'">
                <VueBarcode :value="serial" :options="barcodeOption"></VueBarcode>
            </div>
            <div v-show="serialType == 'CODE'">
                <div class="font-bold tracking-3px text-32 w-52 text-center">{{serial}}</div>
                <button class="copy_btn" 
                    v-clipboard:copy="serial"
                    v-clipboard:success="onCopy">
                    <img src="@/assets/icon/serial/copy.svg" class="copyimg" alt="copy" /> {{ lbl.serial.copy }}</button>
            </div>
        </div>

        <div class="my-3" v-if="isCampaignPrivilege20()"> 
            <Unlock @unlock="complete()"></Unlock>
        </div>

        <div class="text-20 text-tc-gray-3 text-center">
            {{lbl.serial.use_on}} {{FilterTimeFormat(serialModel.redeemTimestamp)}}
        </div>
    </div>
</template>
<script>
//import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";  
import { CampaignType } from "@/helper/StaticValue.js";
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';
//import SlideUnlock from "@j2only/slide-unlock"  
import Unlock from '@/module/Detail/modal/SerialModal/component/Unlock.vue';

export default {
    name: "Serial",
    mixins: [LocaleMixin],
    components: {
        VueBarcode,
        VueQrcode,
        Unlock, 
    },
    props: {
        serialModel: Object,
    },
    data: function() {
        return {
            serialType: 'CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: 'bg-tc-gray-5',

            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',

            qrOption: {
                width: 160,
                margin: 0,
            },
            barcodeOption: {
                height: 100,
                displayValue: false,
                lineColor: '#000000',
                width: 1,
            },
        };
    },
    created: function() {
        this.initial();
        //Util.log('modalSerial', this.serialModel); 
    }, 
    methods: {
        isCampaignPrivilege20: function() {
            return this.serialModel.campaign.type == CampaignType.Privilege20;
        },
        initial: function () {
            if (!this.serialModel.serial) {
                return;
            }

            this.isExpired = false;
            this.serial = this.serialModel.serial;
            switch (this.serialModel.barcode) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.serialModel.barcode && this.serialModel.barcode.toLowerCase() == 'none' && this.serialModel.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },

        setSerialExpire: function() {
            this.serial = "XXXXXX";
            this.isExpired = true;
            this.isTabLock = true;
            this.serialType = "CODE";
        },

        complete: function() {
            //console.log('complete');
            this.$emit('useSerial');
        },
        onCopy: function() {
            console.log('onCopy'); 
        },
    },
}
</script>
<style lang="scss" scoped>
.wrap-code {
    height: 200px;
}
//  .slideunlock {
//     width: 214px !important;
//     margin: 0 auto;
//     border: 1px solid #1C3E95 ;
    
//     --su-size-padding: 3px;
//     --su-size-text: 20px;
//     --su-color-bg: #fff;
//     --su-color-text-normal: #1C3E95; 
//     --su-color-progress-normal-bg: #fff;
//     --su-color-progress-complete-bg: #fff;
//     --su-icon-handler: url(./../../../../../assets/icon/arrow.svg);
         
//     .slideunlock-text {  
//         font-style: normal;
//         font-weight: 500;
        
//     } 
// }
.copy_btn {
    margin: 0 auto;
    display: flex;
    padding: 4px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 40px;
    border: 1px solid #1C3E95;
 
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    color: #1C3E95;

    .copyimg {
        width: 22px;
        height: 22px;
    }
}
</style>

<style lang="scss">
// .slideunlock .slideunlock-handler { 
//     background-size: 54px;
// }
</style>